import React from 'react';
import { IconExclamationCircle, Text } from '@zillow/constellation';
import { StyledContentBox } from './StyledComponents';

const NotViewableMessage = (props) => {
    const { feedName, feedId } = props;
    const content = `You can manage 3D tours on this page. Other listing details, such as pricing
    and availability, are updated through a feed. To edit those details, return to ${feedName || feedId}.`;
    return (
        <StyledContentBox highlight="blue">
            <IconExclamationCircle
                marginRight="sm"
                size="lg"
            />
            <Text fontType="body">
                {content}
            </Text>
        </StyledContentBox>
    );
};

export default NotViewableMessage;
